import { DiscussionObjectTypeConstants } from "src/constants";
import { CreateDiscussionThreadRequest } from "src/service/interaction";
import { sentenceOrPascalToCamel } from "src/utils";

import { DiscussionVisibilityConstants } from "../../../constants/discussion/DicussionVisibilityConstants";
import { getOrganisationsForDiscussion } from "../../../service/query/QueryService.full";
import { Status } from "../../../service/Shared";

export const fetchTargetOrgUuids = async (
  objectUuid: string,
  currentOrganisationUuid: string
): Promise<string[] | null> => {
  const res = await getOrganisationsForDiscussion({
    objectType: sentenceOrPascalToCamel(DiscussionObjectTypeConstants.WORKFLOW_TASK),
    objectUuid,
  }).catch(() => null);
  return res?.status === Status.Success && res.data
    ? res.data.filter((o) => o.uuid !== currentOrganisationUuid).map((o) => o.uuid)
    : null;
};

export const buildCreateThreadParams = (
  objectUuid: string,
  content: string,
  sourceOrganisationUuid: string,
  targetOrganisationUuids: string[] | null
): CreateDiscussionThreadRequest => ({
  threadObjectType: DiscussionObjectTypeConstants.WORKFLOW_TASK,
  threadObjectUuid: objectUuid,
  threadType: "Discussion",
  visibility: DiscussionVisibilityConstants.EXTERNAL,
  messageContent: content,
  messageType: "Comment",
  messageObjectType: DiscussionObjectTypeConstants.WORKFLOW_TASK,
  messageObjectUuid: objectUuid,
  messageStatus: "Published",
  messageSourceOrganisationUuid: sourceOrganisationUuid,
  messageTargetOrganisationUuids: targetOrganisationUuids,
  componentKey: null,
  dataPath: null,
});
